import en from './strings.en';

const ru = {
    header: 'Топ-3 перевозчиков по направлению',
    description: {
        one: 'Мы выделили перевозчика,\nкоторый будет максимально заинтересован в вашем грузе.',
        count: 'Мы выделили {{count}} перевозчиков,\nкоторые будут максимально заинтересованы в вашем грузе.',
        default: 'Мы выделили перевозчиков,\nкоторые будут максимально заинтересованы в вашем грузе.',
    },
    ask: 'Поделитесь мнением',
};

export default { ru, en: { ...ru, ...en} };
